import gql from 'graphql-tag';
import fragments from '../fragments.js';

export default {
    campaignAnalytics: gql`
        query CampaignAnalytics($campaignID: String!) {
            analytics(campaignID: $campaignID) {
                funnel
            }
            campaignAnalytics(campaignID: $campaignID) {
                sentimentCountPositive
                sentimentCountNegative
                sentimentCountMixed
                sentimentCountNeutral
                sentimentCountUndetermined
                genderCountMale
                genderCountFemale
                genderCountUndetermined
                locationCountryCount {
                    name
                    count
                }
                locationRegionCount {
                    name
                    count
                    country
                }
                locationCityCount {
                    name
                    count
                    country
                }
                contributionHistogram {
                    start
                    end
                    count
                }
                nps {
                    promotersCount
                    detractorsCount
                    passivesCount
                }
                csat {
                    oneStarCount
                    twoStarCount
                    threeStarCount
                    fourStarCount
                    fiveStarCount
                }
                requiresFollowup {
                    ...PostWithSensitiveDataFragment
                }
                greatForMarketing {
                    ...PostWithSensitiveDataFragment
                }
                brandLoyaltyCount
                satisfactionCount
                disappointedCount
                passionateCount
                buyAgainYesCount
                buyAgainNoCount
                lastPost {
                    ...PostWithSensitiveDataFragment
                }
            }
        }

        ${fragments.postWithSensitiveData}
        ${fragments.image}
        ${fragments.audio}
    `,
};
